// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1S_dX","filesListContainer":"PosDisputesFiles_filesListContainer__3Xw0D","filesButton":"PosDisputesFiles_filesButton__1Aag-"};